import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class ClipPath extends BaseOption {
  static userInterfaceComponent = {
    label: "Clip Path",
    component: inspectorTools.CLIP_PATH,
  };

  static defaultValue = "";
}
